import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useIsMobile } from "../shared/hooks/useIsMobile";
import BottomTabs from "../shared/components/BottomTabs";
import MobileShell from "./MobileShell";
import DesktopShell from "./DesktopShell";
import MainTabLayer from "./MainTabLayer";
import ProfileDetails from "../features/profile/ProfileDetails";
import { useTabSwitch } from "./TabSwitchContext";
import {
  isEditOnboardingRoute,
  isMainTabRoute,
  isOnboardingRoute,
} from "./mainTabRoutes";
import { isProfileSubpageRoute } from "./profileSubpageNav";

function MobileShellContent() {
  const { pathname, state } = useLocation();
  const { visualTab } = useTabSwitch();
  const onMainTab = isMainTabRoute(pathname);
  const isEditOnboarding = isEditOnboardingRoute(pathname, state);
  const isProfileSubpage = isProfileSubpageRoute(pathname, state);
  const isAuthFromTab = ["/auth", "/signin", "/register"].includes(pathname)
    && (state?.fromTab === "home" || state?.fromTab === "reels");
  const showTabLayer = onMainTab || isAuthFromTab || isEditOnboarding || isProfileSubpage;
  const showOutlet = !onMainTab || isAuthFromTab || isOnboardingRoute(pathname) || isProfileSubpage;
  const lockShellScroll = onMainTab && !isAuthFromTab;
  const reelsActive = visualTab === "reels" || pathname.startsWith("/reels");

  return (
    <MobileShell reelsActive={reelsActive} lockScroll={lockShellScroll}>
      <MainTabLayer pathname={pathname} hidden={!showTabLayer} />
      {showOutlet ? <Outlet /> : null}
    </MobileShell>
  );
}

function DesktopShellContent() {
  const { pathname, state } = useLocation();
  const isEditOnboarding = isEditOnboardingRoute(pathname, state);
  const isProfileSubpage = isProfileSubpageRoute(pathname, state);
  const showProfileUnderlay = isEditOnboarding || isProfileSubpage;

  return (
    <DesktopShell>
      {showProfileUnderlay ? (
        <>
          <div className="desktop-edit-profile-underlay" aria-hidden>
            <ProfileDetails />
          </div>
          <Outlet />
        </>
      ) : (
        <Outlet />
      )}
    </DesktopShell>
  );
}

export default function ResponsiveShell() {
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile ? (
        <MobileShellContent />
      ) : (
        <DesktopShellContent />
      )}
      <BottomTabs />
    </>
  );
}
